import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../api/client";

function Privacy() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/api/v1/legal/privacy")
      .then((res) => setData(res.data))
      .catch((err) => console.error("Failed to load privacy policy:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-400" />
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold text-white mb-2">
        {data?.content?.title || "Privacy Policy"}
      </h1>
      <p className="text-sm text-gray-500 mb-8">
        Effective Date: {data?.effective_date || "July 21, 2026"}
      </p>
      <div className="space-y-6">
        {data?.content?.sections?.map((section, index) => (
          <div
            key={index}
            className="bg-gray-900 rounded-lg p-6 border border-gray-800"
          >
            <h2 className="text-lg font-semibold text-white mb-2">
              {section.heading}
            </h2>
            <p className="text-gray-400">{section.text}</p>
          </div>
        ))}
      </div>
      <p className="text-center text-gray-500 text-sm mt-8">
        <Link to="/" className="text-cyan-400 hover:underline">
          Back to Home
        </Link>
      </p>
    </div>
  );
}

export default Privacy;
